import { render, staticRenderFns } from "./modal-upload-image.vue?vue&type=template&id=8ef1c2da"
import script from "./modal-upload-image.vue?vue&type=script&lang=js"
export * from "./modal-upload-image.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports